import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#A566A1",
  "fill-rule": "evenodd",
  d: "M8.38 8.856a.737.737 0 0 1-1.043 0L4.523 6.042 1.71 8.856A.737.737 0 0 1 .667 7.814L3.481 5 .667 2.186A.737.737 0 1 1 1.71 1.144l2.814 2.814 2.814-2.814A.737.737 0 1 1 8.38 2.186L5.565 5 8.38 7.814a.737.737 0 0 1 0 1.042Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }